import "./_vendor";
import vars from "./_vars";
import "./_functions";
import "./_components";

import Lenis from "@studio-freight/lenis";
import AOS from "aos";

const lenis = new Lenis();

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// Модальное окно
const modal = document.querySelector("#callback-modal");
if (modal) {
  const openButtons = document.querySelectorAll(
    ".hero__btn, .about__btn, .location__btn, .surroundings__btn, .apartments-intro__btn, .apartments-select__promo-btn, .apartments-select__card-btn, .footer__btn, .schuco-text__btn, .facade-photo__btn",
  );
  const closeButton = modal.querySelector(".modal__close");
  const overlay = modal.querySelector(".modal__overlay");

  const openModal = (e) => {
    e.preventDefault();
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  openButtons.forEach((btn) => btn.addEventListener("click", openModal));
  if (closeButton) closeButton.addEventListener("click", closeModal);
  if (overlay) overlay.addEventListener("click", closeModal);
}

// Универсальное открытие модалок
document.querySelectorAll("[data-modal-trigger]").forEach((trigger) => {
  trigger.addEventListener("click", () => {
    const modalId = trigger.getAttribute("data-modal-trigger");
    const targetModal = document.getElementById(modalId);
    if (targetModal) {
      targetModal.classList.add("is-open");
      document.body.style.overflow = "hidden";

      const closeBtn = targetModal.querySelector(".modal__close");
      const overlay = targetModal.querySelector(".modal__overlay");

      const close = () => {
        targetModal.classList.remove("is-open");
        document.body.style.overflow = "";
      };

      closeBtn?.addEventListener("click", close, { once: true });
      overlay?.addEventListener("click", close, { once: true });
    }
  });
});

// Кнопка "Наверх"
const toTopBtn = document.querySelector("#toTop");
if (toTopBtn) {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 500) {
      toTopBtn.classList.add("is-show");
    } else {
      toTopBtn.classList.remove("is-show");
    }
  });

  toTopBtn.addEventListener("click", () => {
    lenis.scrollTo(0);
  });
}

// FAB (Floating Action Button)
const fab = document.querySelector("#fab");
if (fab) {
  const fabMain = fab.querySelector(".fab__main");
  const fabModalBtn = fab.querySelector(".fab__item--modal");

  fabMain.addEventListener("click", () => {
    fab.classList.toggle("is-active");
  });

  if (fabModalBtn) {
    fabModalBtn.addEventListener("click", (e) => {
      e.preventDefault();
      fab.classList.remove("is-active");
      const modal = document.querySelector("#callback-modal");
      if (modal) {
        modal.classList.add("is-open");
        document.body.style.overflow = "hidden";
      }
    });
  }

  // Закрытие при клике вне
  document.addEventListener("click", (e) => {
    if (!fab.contains(e.target)) {
      fab.classList.remove("is-active");
    }
  });
}

window.addEventListener("load", () => {
  const preloader = document.querySelector(".preloader");
  setTimeout(() => {
    if (preloader) {
      preloader.classList.add("preloader--hidden");
    }
    AOS.init({
      duration: 1000,
      once: true,
      offset: 0,
    });
  }, 1500);
});

// Обновление AOS при скролле Lenis
lenis.on("scroll", (e) => {
  AOS.refresh();

  // Параллакс для Schuco
  const schucoImg = document.querySelector(".schuco-photo__img img");
  if (schucoImg) {
    const rect = schucoImg.parentElement.getBoundingClientRect();
    const speed = 0.15;
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      const yPos = -(rect.top * speed);
      schucoImg.style.transform = `scale(1.2) translateY(${yPos}px)`;
    }
  }
});

import SmoothScroll from "smooth-scroll";
const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 800,
  speedAsDuration: true,
});
